"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyLabelSchema = exports.LabelCategorySchema = exports.LabelTimeSchema = void 0;
const zod_1 = require("zod");
exports.LabelTimeSchema = zod_1.z
    .object({
    kind: zod_1.z.literal('time'),
    // start: z.string(),
    // end: z.string(),
    start: zod_1.z.date({ coerce: true }).openapi({ type: 'string', format: 'date-time' }),
    end: zod_1.z.date({ coerce: true }).openapi({ type: 'string', format: 'date-time' }),
})
    .openapi('TimeLabel');
exports.LabelCategorySchema = zod_1.z
    .object({
    kind: zod_1.z.literal('category'),
    key: zod_1.z.string(),
    display_name: zod_1.z.string().optional(),
})
    .openapi('CategoryLabel');
exports.AnyLabelSchema = zod_1.z
    .discriminatedUnion('kind', [exports.LabelTimeSchema, exports.LabelCategorySchema])
    .openapi('Label');
//# sourceMappingURL=labelSchema.js.map